/* eslint-disable react/prop-types */
import React from 'react';
import { Modal, Button, notification, Input } from 'antd';
import { authenticateCurrentUser } from '../services/auth';
import { sendLoginCredentialsEmail } from '../services/userManagement';

const ResetPasswordModal = (props) => {
  const {
    resetPasswordModalVisible,
    setResetPasswordModalVisible,
    resetPasswordModalLoading,
    setResetPasswordModalLoading,
    resetPasswordRecord,
    setResetPasswordRecord,
  } = props;

  const handleCancel = () => {
    setResetPasswordRecord([]);
    setResetPasswordModalVisible(false);
  };

  const handleSendResetLink = async () => {
    if (!resetPasswordRecord?.email) {
      notification.error({ message: 'User email not found' });
      return;
    }

    setResetPasswordModalLoading(true);

    try {
      const currentUser = await authenticateCurrentUser();
      const currentUserEmail =
        currentUser?.attributes?.email || currentUser?.username || 'Administrator';

      const username =
        resetPasswordRecord.user_id ||
        resetPasswordRecord.username ||
        resetPasswordRecord.email.toLowerCase().trim();

      const result = await sendLoginCredentialsEmail({
        email: resetPasswordRecord.email,
        cognitoUsername: username,
        creatorEmail: currentUserEmail,
      });

      if (result.success) {
        notification.success({
          message: 'Credentials sent successfully!',
          description: `${resetPasswordRecord.email} will receive an email with their login details.`,
          duration: 4,
        });
        handleCancel();
      } else {
        throw new Error(result.error || 'Failed to send credentials');
      }
    } catch (error) {
      console.error('Error sending credentials:', error);
      notification.error({
        message: 'Failed to send credentials',
        description: error.message || 'Please try again.',
      });
    } finally {
      setResetPasswordModalLoading(false);
    }
  };

  return (
    <Modal
      className="quality-modal heatprofile-modal"
      title="Reset Password"
      centered
      width={600}
      visible={resetPasswordModalVisible}
      onCancel={handleCancel}
      footer={[
        <Button
          key="cancel"
          size="large"
          onClick={handleCancel}
          disabled={resetPasswordModalLoading}
        >
          Cancel
        </Button>,
        <Button
          key="sendLink"
          type="primary"
          size="large"
          loading={resetPasswordModalLoading}
          disabled={resetPasswordModalLoading}
          onClick={handleSendResetLink}
        >
          {resetPasswordModalLoading ? 'Sending...' : 'Send Credentials Email'}
        </Button>,
      ]}
    >
      <div className="reset-password-content">
        <p className="reset-password-message">
          Are you sure you want to <strong>reset the password</strong> for{' '}
          <strong>{resetPasswordRecord?.name || resetPasswordRecord?.email}</strong>?
        </p>

        <p className="reset-password-description">
          The user will receive an email with their new password and a link to sign in at the login
          page (platformLink from server .env).
        </p>

        {resetPasswordRecord?.email && (
          <div className="reset-password-field reset-password-email-block">
            <label className="reset-password-label" htmlFor="reset-password-user-email">
              User email
            </label>
            <Input
              id="reset-password-user-email"
              value={resetPasswordRecord.email}
              readOnly
              size="large"
              aria-readonly="true"
              style={{ background: '#f5f5f5', color: '#1f2937', borderColor: '#d1d5db' }}
            />
          </div>
        )}
      </div>
    </Modal>
  );
};

export default ResetPasswordModal;
